import { createSlice } from "@reduxjs/toolkit";
import { LanguageID } from "configs";

export interface SystemReducerState {
  language: LanguageID;
  internalServerError?: boolean;
}

const initialState: SystemReducerState = {
  language: LanguageID.uk,
  internalServerError: false,
};

export const systemSlice = createSlice({
  name: "System",
  initialState,
  reducers: {
    showInternalServerError: (state) => {
      state.internalServerError = true;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    reset: (state) => {
      state.internalServerError = undefined;
    },
  },
});
